import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import Nestable from "react-nestable";
import FileIconImg from "components/Accordion/FileIconImg";
import httpClient from "utility/httpClient.util";
import useAuth from "hooks/useAuth";
import Swal from "sweetalert2";
const FolderMenu = (props) => {
  const { codeFolder, id="" } = props;
  const { user } = useAuth();
  const [defaultCollapsed] = useState(false);
  const [items, setItems] = useState([]);
  const [activeFolder, setActiveFolder] = useState("");
  const refNestable = useRef(null);
  const refNestableHandler = useRef(null);
  const [favoriteFolder, setFavoriteFolder] = useState([]);
  const [folderList, setFolderList] = useState([]);

  const onselectFolder = (item) => {
    const folderPermission = folderList.filter(
      (obj) => obj.folderId === item?.id
    );

    const permission = folderPermission[0]?.permissions;
    if (permission?.length > 0 && permission !== null) {
      const hasAccess = permission?.some((permission) =>
        user?.groups[0]?.includes(permission?.path)
      );
      if (hasAccess) {
        setActiveFolder(item?.id);
        props.getFolderId(item);
      } else {
        Swal.fire({
          icon: "error",
          title: "Permission Denied",
          text: "You do not have permission to upload.",
        });
      }
    } else {
      setActiveFolder(item?.id);
      props.getFolderId(item);
    }
  };

  const transformDataToTree = (data) => {
    const map = {};
    const tree = [];

    data.forEach((item) => {
      map[item.folderId] = { id: item.folderId, text: item.name, children: [] };
    });

    data.forEach((item) => {
      const node = map[item.folderId];
      if (
        item.parentFolderId === null ||
        item.parentFolderId === item.rootFolderId
      ) {
        tree.push(node);
      } else {
        const parent = map[item.parentFolderId];
        if (parent) {
          parent.children.push(node);
        }
      }
    });
    return tree;
  };

  const buildNestableItems = (data, parentId = null) => {
    return data
      .filter((item) => item.parentFolderId === parentId)
      .map((item) => ({
        id: item.folderId,
        text: item.name,
        children: buildNestableItems(data, item.folderId),
      }));
  };

  const getFolderList = async () => {
    let code = codeFolder;
    if (code) {
      await httpClient.get(`/document/folder/list/${code}`).then((res) => {
        if (res) {
          const folderData = res.data.data;
          setFolderList(folderData);
          const nestableItems = transformDataToTree(folderData);
          setItems(nestableItems);

          if (folderData) {
            const newFavorite = folderData
              .filter((item) => item.isFavorite === 1)
              .map((item) => item);

            setFavoriteFolder(newFavorite);
          }
        }
      });
    }
  };

  const toggleFavoriteFolder = (item) => {
    setFavoriteFolder((prevFavorites) => {
      const isFavorite = prevFavorites.some((fav) => fav.folderId === item.id);

      if (isFavorite) {
        updateFavoriteFile(0, item.id);
        return prevFavorites.filter((fav) => fav.folderId !== item.id);
      } else {
        updateFavoriteFile(1, item.id);
        return [...prevFavorites, item];
      }
    });
  };

  const getFavorite = (id) => {
    return favoriteFolder?.some((fav) => fav?.folderId === id);
  };

  const updateFavoriteFile = async (status, id) => {
    const body = { isFavorite: status };
    await httpClient.put(`/document/folder/${id}`, body);
    await getFolderList();
  };

  useEffect(() => {
    getFolderList();
  }, [codeFolder]);



  useEffect(() => {
    setActiveFolder(id);
  }, [id]);

  useEffect(() => {}, [favoriteFolder]);
  useEffect(() => {
    if (folderList?.length > 0 && id === "") {
      const folderWithPermission = folderList.find((folder) =>
        folder?.permissions?.some((permission) =>
          user?.groups[0]?.includes(permission?.path)
        )
      );
      if (folderWithPermission) {
        props.getFolderId(folderWithPermission?.folderId);
        setActiveFolder(folderWithPermission?.folderId);
      } 
    }
  }, [folderList]);

  const collapse = (collapseCase) => {
    if (refNestable || refNestableHandler) {
      switch (collapseCase) {
        case 0:
          refNestable && refNestable.current.collapse("NONE");
          // refNestableHandler && refNestableHandler.current.collapse('NONE');
          break;
        case 1:
          refNestable && refNestable.current.collapse("ALL");
          //  refNestableHandler && refNestableHandler.current.collapse('ALL');
          break;
        case 2:
          refNestable && refNestable.current.collapse([1]);
          //   refNestableHandler && refNestableHandler.current.collapse([1]);
          break;
        default:
          refNestable && refNestable.current.collapse("NONE");
          //   refNestableHandler && refNestableHandler.current.collapse('NONE');
          break;
      }
    }
  };

  const renderItem = ({ item, collapseIcon, handler }) => {
    const hasCollapsed = collapseIcon || false;
    return (
      <div className="pc-nestable-item" onClick={() => onselectFolder(item)}>
        <Row
          className="row align-items-center"
          style={{
            color: activeFolder === item?.id ? "blue" : "black",
            backgroundColor: activeFolder === item?.id ? "#E0E0E0" : "",
          }}
        >
          <Col className="col">
            {/* {handler} */}
            {collapseIcon}
            {item?.attachmentId && <FileIconImg file={item} />}
            {!item?.attachmentId && !hasCollapsed && (
              <i
                className="fas fa-folder-plus f-18 ml-1 mr-1"
                style={{ color: "lightblue" }}
              />
            )}
            {item?.text}
          </Col>
          <Col className="col-auto">
            <div
              onClick={() => {
                toggleFavoriteFolder(item);
              }}
            >
              {getFavorite(item.id) === true ? (
                <i
                  className="feather icon-bookmark mr-1"
                  style={{ color: "orange" }}
                />
              ) : (
                <i
                  className="feather icon-star mr-1"
                  style={{ color: "orange" }}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const renderExampleOne = () => {
    return (
      <div>
        <Nestable
          items={items}
          collapsed={defaultCollapsed}
          renderItem={renderItem}
          handler={null}
          disableDrag={true}
          renderCollapseIcon={({ isCollapsed }) => (
            <i
              style={{ color: "darkgray" }}
              className={
                "f-18 fas ml-1 mr-1 " +
                (isCollapsed ? "fa-chevron-right" : "fa-chevron-down")
              }
            />
          )}
          onChange={() => {}} // Prevent any changes
          ref={refNestable}
        />
      </div>
    );
  };

  const renderExampleTwo = () => {
    return (
      <div>
        <Nestable
          items={items}
          collapsed={defaultCollapsed}
          renderItem={renderItem}
          handler={<span className="pc-nestable-item-handler" />}
          ref={refNestableHandler}
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <Card className="document-folder">
        <Card.Body className="p-2">
          <Row>
            <Col md={12}>
              {favoriteFolder?.length > 0 && (
                <>
                  <h6 className="mt-2"> Favorite Folder</h6>
                  <Row>
                    {favoriteFolder.map((folder) => (
                      <Col
                        md={12}
                        key={folder.attachmentId}
                        className="d-flex mb-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => onselectFolder(folder)}
                      >
                        <i
                          className="fas fa-folder-plus f-18 ml-1 mr-1"
                          style={{ color: "lightblue" }}
                        />
                        {folder?.name}
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            </Col>

            <Col sm={12} md={12}>
              <h6> Folder Upload</h6>
              {renderExampleOne()}
              {folderList?.length === 0 && (
                <div className="mt-3">
                  <h6>No Folder Available</h6>
                </div>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default FolderMenu;
